import get from 'lodash/get';

export const createDraftTransfer = ({
  props,
  destAccount,
  state,
  newTransfer,
  creditTransferTypes,
  transferFeeConfigData, 
  realtorData,
  status,
  method,
  office,
}) => {

  let fee = 0;
  const [tfg] = transferFeeConfigData;
  if (tfg && tfg.clientPays) {
    fee = tfg.amount;
  }

  // Get the current UTC date for createdAt and updatedAt
  const currentUTCDate = new Date().toISOString();

  return {
    ...newTransfer,
    fee: fee,
    firstName: get(props.client, 'firstName'),
    lastName: get(props.client, 'lastName'),
    email: get(props.client, 'email'),
    status: 'draft',
    otherIndividuals: JSON.stringify(realtorData),
    debitMethod: method,
    transferType: {
      link: creditTransferTypes.filter((f) => f.name === 'Client Transfer')[0]._id,
    },
    type: 'Client Transfer',
    client: { link: get(props, 'client._id') },
    sourceBankAccount: { link: get(state, 'data.bankAccount._id') },
    tenant: { link: get(props, 'tenant._id') },
    ...(office ? { office: { link: office._id } } : null),

    // Below fields are needed for mongoDB
    createdAt_utc: currentUTCDate,
    updatedAt_utc: currentUTCDate,
    createdAt_offset: "+00:00",
    updatedAt_offset: "+00:00",
  };
}

